export function useDebtorAPI() {
  const { errors, request } = useRequest();

  async function searchDebtors(searchQuery: string) {
    const url = `${versionedUrl('Debtor/SearchDebtors')}?searchQuery=${encodeURIComponent(searchQuery)}`;

    return await request<AppSearchDebtor[]>(url);
  }

  async function getDebtorByID(id?: number) {
    const url = `${versionedUrl('Debtor/GetDebtorByID')}?id=${id}`;

    return await request<AppSearchDebtor>(url);
  }

  return {
    errors,
    searchDebtors,
    getDebtorByID
  };
}
